import React, {useRef} from 'react';

import {FmlxBadge, FmlxIcon} from 'fmlx-common-ui';

import ERROR_FILE_ICON from '@/assets/icons/si-glyph-document-error.svg';

import './ManualProfileSequence.less';

// eslint-disable-next-line react/prop-types
function ManualProfileSequence({label, onClick, id, sequenceNotFound, isPreloaded, active, isFavorite}) {
  const anchorEl = useRef(null);

  return (
    <div
      className="parentSequenceSetup"
      onClick={onClick}
      id={id}
    >
      <div className="row sequenceSetupIcon center">
        {!sequenceNotFound &&
          (isPreloaded ? (
            <FmlxIcon
              name="FileUtilityFilled"
              customSize="50px"
              customColor={active ? '#F7A246' : '#313131'}
            />
          ) : (
            <div
              ref={anchorEl}
              style={{position: 'relative'}}
            >
              {isFavorite && (
                <FmlxBadge
                  anchorEl={anchorEl}
                  position={{vertical: 'top', horizontal: 'right'}}
                >
                  <FmlxIcon
                    name="StartFilled"
                    customColor="#FFFFF"
                  />
                </FmlxBadge>
              )}
              <FmlxIcon
                name="FileFilled"
                customSize="50px"
                customColor={active ? '#F7A246' : '#313131'}
              />
            </div>
          ))}
        {sequenceNotFound && (
          <img
            src={ERROR_FILE_ICON}
            alt={ERROR_FILE_ICON}
            height={50}
            width={50}
            className="glyphicon glyphicon-file icon"
          />
        )}
      </div>
      <div className="row sequenceSetupLabel">
        <span>{label}</span>
      </div>
    </div>
  );
}

export default ManualProfileSequence;
